<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-gale`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36 32l.001.027a6.5 6.5 0 11-5.326 10.93l-.188-.207 3.026-2.616a2.5 2.5 0 102.057-4.128L35.406 36H5a1 1 0 01-1-1v-2a1 1 0 011-1h31zm-1-8a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2a1 1 0 011-1h26zm1-20a8 8 0 01.25 15.996L36 20H5a1 1 0 01-.993-.883L4 19v-2a1 1 0 01.883-.993L5 16h31l.2-.005a4 4 0 10-2.722-7.1l-.173.15-2.697-2.955.235-.206A7.975 7.975 0 0136 4z"/></svg>
</template>
<script>

export default {
  name: 'IconGale',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
